module.exports = __webpack_public_path__ + "images/emoji/lock.42aa403ef7385dcae532.png";